import React from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import { withPolling } from "MODULES/shared/decorators";
import {
  SalesCount,
  SaleLinesCount,
  SalesProfit,
  SalesPercentProfit,
  GrossSalesSum
} from "./Stats";

function HeaderStats({ salesData }) {
  return (
    <Row>
      <Col md={2} mdOffset={1}>
        <SalesCount dateLabel="Today" data={salesData} />
      </Col>
      <Col md={2}>
        <SaleLinesCount dateLabel="Today" data={salesData} />
      </Col>
      <Col md={2}>
        <GrossSalesSum data={salesData} dateLabel="Today" />
      </Col>
      <Col md={2}>
        <SalesProfit dateLabel="Today" data={salesData} />
      </Col>
      <Col md={2}>
        <SalesPercentProfit dateLabel="Today" data={salesData} />
      </Col>
    </Row>
  );
}

HeaderStats.propTypes = {
  salesData: T.arrayOf(T.shape({}))
};

export default withPolling(HeaderStats);



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/Components/HeaderStats.jsx